import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import themeBg from "../assets/images/Travel/themeBg.png";
import tripAdvisor from "../assets/images/Travel/tripAdvisor.png";
import TravelLinkService from "../services/TravelLinkService/TravelLinkService";

const Footer = () => {
  const [affiliateData, setAffiliateData] = useState([]);
  const fetchAffiliate = async () => {
    try {
      const response = await TravelLinkService.getAffiliate();
      setAffiliateData(response);
    } catch (error) {
      console.logerror;
    }
  };

  const [paymentMethod, setPaymentMethod] = useState([]);

  const fetchPaymentMethod = async () => {
    try {
      const response = await TravelLinkService.getPaymentMethod();
      setPaymentMethod(response);
    } catch (error) {
      console.logerror;
    }
  };

  const [data, setData] = useState([]);
  console.log("🚀 ~ Footer ~ data:", data);

  const fetchData = async () => {
    try {
      const response = await TravelLinkService.getGeneralSetting();
      console.log("🚀 ~ fetchData ~ response:", response);
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchPaymentMethod();
    fetchAffiliate();
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <div style={{ backgroundColor: "#0E9EDA", color: "white" }}>
        <footer
          className="ter foobackground-image-overlay"
          style={{
            position: "relative",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden", // Ensure that the pseudo-element is contained
          }}
        >
          <div
            style={{
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${themeBg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              opacity: 0.35,
              zIndex: 1,
            }}
          ></div>

          <Container fluid>
            <Row className=" mt-3" style={{ position: "relative", zIndex: 2 }}>
              {/* <Col
                sm={2}
                xs={12}
                className="mb-2 d-flex justify-content-center"
              >
                <img
                  src={data?.company_logo_url}
                  style={{ height: "70px", width: "auto" }}
                  alt="Travel link Logo"
                />
              </Col> */}
              {/* Left Section */}
              <Col
                sm={4}
                xs={12}
                className="d-flex justify-content-center text-center mb-2"
              >
                {data ? (
                  <ul className="list-unstyled" style={{ lineHeight: "30px" }}>
                    <li>
                      <h6 className="text-white text-decoration-underline">
                        Quick Contact
                      </h6>
                    </li>
                    {data.contact_address && (
                      <li className="d-flex gap-3">
                        <i className="ri-map-pin-line"></i>
                        <h6 className="text-white mt-2">
                          {data.contact_address}
                        </h6>
                      </li>
                    )}
                    {data.contact_gpo && (
                      <li className="d-flex gap-3">
                        <i
                          className="bx bx-box"
                          style={{ marginTop: "8px" }}
                        ></i>
                        <h6 className="text-white mt-2">{data.contact_gpo}</h6>
                      </li>
                    )}
                    {data.contact_phone && (
                      <li className="d-flex gap-3">
                        <i className="ri-phone-line"></i>
                        <h6 className="text-white mt-2">
                          {data.contact_phone}
                        </h6>
                      </li>
                    )}
                    {data.contact_mobile && (
                      <li className="d-flex gap-3">
                        <i className="ri-whatsapp-line"></i>
                        <h6 className="text-white mt-2">
                          {data.contact_mobile}
                        </h6>
                      </li>
                    )}
                    {data.contact_email && (
                      <li className="d-flex gap-3">
                        <i className="ri-mail-line"></i>
                        <h6 className="text-white mt-2">
                          {data.contact_email}
                        </h6>
                      </li>
                    )}
                  </ul>
                ) : (
                  <h6 className="text-white">No contact data available</h6>
                )}
              </Col>

              {/* Center Section */}
              <Col
                sm={4}
                xs={12}
                className="d-flex justify-content-center text-center text-white mb-2 mt-0"
                style={{ opacity: 1 }}
              >
                <ul
                  className="list-unstyled d-flex flex-wrap flex-sm-column justify-content-center"
                  style={{ lineHeight: "30px" }}
                >
                  <li className="w-100 text-center">
                    <h6 className="text-white text-decoration-underline">
                      Quick Links
                    </h6>
                  </li>
                  <li className="px-2">
                    <Link to="/home" className="text-white">
                      Home
                    </Link>
                  </li>
                  <li className="px-2">
                    <Link to="/services" className="text-white">
                      Services
                    </Link>
                  </li>
                  <li className="px-2">
                    <Link to="/destination" className="text-white">
                      Destination
                    </Link>
                  </li>
                  <li className="px-2">
                    <Link to="/contact-us" className="text-white">
                      Contact Us
                    </Link>
                  </li>
                  <li className="px-2">
                    <Link to="/testimonials" className="text-white">
                      Testimonials
                    </Link>
                  </li>
                  <li className="px-2">
                    <Link to="/blog" className="text-white">
                      Blogs
                    </Link>
                  </li>
                </ul>
              </Col>

              {/* Right Section */}
              <Col
                sm={4}
                xs={12}
                className="d-flex flex-column justify-content-center text-center text-white mb-2"
                style={{ opacity: 1, lineHeight: "4.1rem" }}
              >
                <Row>
                  <Col md={12} xs={6}>
                    <ul className="list-unstyled">
                      <li>
                        <h6 className="text-white text-decoration-underline">
                          Reviewed By
                        </h6>
                      </li>
                      <li className="mb-3">
                        {data?.reviewed_links_Urls?.map((item, index) => (
                          <a
                            href={item.url}
                            key={index}
                            className=""
                            target="_blank"
                          >
                            <img src={item?.icon} style={{ width: "100px" }} />
                          </a>
                        ))}
                      </li>
                    </ul>
                  </Col>
                  <Col md={12} xs={6}>
                    <ul className="list-unstyled">
                      <li>
                        <h6 className="text-white text-decoration-underline">
                          Follow Us
                        </h6>
                      </li>
                      <li>
                        <div className="d-flex justify-content-center gap-3">
                          {data?.social_links?.map((item, index) => (
                            <a
                              href={item.url}
                              key={index}
                              className="text-center text-white"
                              target="_blank"
                            >
                              <i
                                className={item.icon}
                                style={{ fontSize: "30px" }}
                              ></i>
                            </a>
                          ))}
                        </div>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr style={{ position: "relative", zIndex: 2 }} />
            <Row style={{ position: "relative", zIndex: 2 }}>
              <Col
                md={4}
                xs={12}
                className="d-flex flex-column justify-content-center align-content-center align-items-center mb-3"
                style={{ opacity: 1, marginBottom: "5px" }}
              >
                <h6 className="text-white text-decoration-underline">
                  Affiliated with
                </h6>
                <div
                  className="d-flex align-items-center gap-3 flex-wrap"
                  style={{ marginBottom: "10px" }}
                >
                  {affiliateData?.map((item, index) => (
                    <img
                      src={item?.image_url}
                      alt={item?.name}
                      style={{
                        width: "60px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      key={index}
                      onClick={() => window.open(item?.link, "_blank")}
                    />
                  ))}
                </div>
              </Col>
              <Col md={4} xs={12}></Col>
              <Col md={4} xs={12} style={{ opacity: 1 }}>
                <h6 className="text-white text-center  text-decoration-underline">
                  We Accept
                </h6>
                <div
                  className="d-flex align-content-center justify-content-center align-items-center gap-3 flex-wrap"
                  style={{ marginBottom: "10px" }}
                >
                  {paymentMethod?.map((item, index) => (
                    <img
                      src={item?.image_url}
                      alt={item?.name}
                      style={{
                        width: "60px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      key={index}
                      onClick={() => window.open(item?.link, "_blank")}
                    />
                  ))}
                </div>
                {/* <div className="d-flex gap-3 align-content-center justify-content-center">
                  <img src={visa} style={{ width: "60px" }} />
                  <img src={americanExpress} style={{ width: "60px" }} />
                  <img src={mastercard} style={{ width: "60px" }} />
                  <img src={discover} style={{ width: "60px" }} />
                </div> */}
              </Col>
            </Row>
            <hr style={{ position: "relative", zIndex: 2 }} />
            <Row
              className="mt-3  text-center mb-3 "
              style={{ position: "relative", zIndex: 2 }}
            >
              <p className="mb-0 fw-bold text-center ">
                Copyright © {new Date().getFullYear()} Travel Link Services. All
                rights reserved.
              </p>
            </Row>
          </Container>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default Footer;
